import { Container } from "@mui/material";
import React from "react";
import { PaginaJosemarIndex } from "../../../components/Admin/Nosotros/josemar/JosemarIndex";

export const PaginaJosemarAdmin = () => {
    return(
        <Container maxWidth='lg'>
                <PaginaJosemarIndex/>
        </Container>
    )
}